import { useAppShellPush } from '@ids/appshell';

const NoMatch = () => {
    const appshellPush = useAppShellPush();

    appshellPush('/');

    return null;
};

export default NoMatch;
